
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("98wGO", function(module, exports) {

$parcel$export(module.exports, "CustomHomepageItem", () => $b3d68fffa22e77da$export$7fbfc66bcecb3243);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $inPa6 = parcelRequire("inPa6");

var $epLE5 = parcelRequire("epLE5");

var $jlIaF = parcelRequire("jlIaF");
var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $kAra1 = parcelRequire("kAra1");
const $b3d68fffa22e77da$var$i18n = (0, $2nPZH.defineMessages)({
    CustomHomeLink: {
        id: "app-navigation.custom.home.link",
        defaultMessage: "Custom Home Page"
    }
});

const $b3d68fffa22e77da$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("04nCC"))).fireCustomHomepageClickedAnalytics);
const $b3d68fffa22e77da$export$7fbfc66bcecb3243 = /*#__PURE__*/ (0, $gwFzn.memo)(({ testId: testId, href: href, label: label })=>{
    const { location: location, match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b3d68fffa22e77da$var$useLazyClickAnalytics(createAnalyticsEvent, match?.name);
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        fireClickAnalytics();
    }, [
        fireClickAnalytics
    ]);
    const isHighlighted = !!location && location.pathname === `${0, $jlIaF.CONTEXT_PATH}${href}` && location.search.includes('mode=global');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAra1.PrimaryItem), {
        testId: testId,
        href: `${(0, $jlIaF.CONTEXT_PATH)}${href}?mode=global`,
        label: label,
        i18n: $b3d68fffa22e77da$var$i18n.CustomHomeLink,
        namedRoute: (0, $1NBp8.WIKI),
        onClick: handleClick,
        isHighlighted: isHighlighted
    });
});

});
parcelRegister("04nCC", function(module, exports) {

let $00d2b2a6b7c53120$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $00d2b2a6b7c53120$var$load("f6Avr").then(()=>parcelRequire('1ouZ7'));

});



//# sourceMappingURL=CustomHomepageItem.e0260114.js.map
